import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X, Share } from "lucide-react";

const KEY = "aranya_install_dismissed";
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [ios, setIos] = useState(false);
  const [hidden, setHidden] = useState(() => !!localStorage.getItem(KEY) || standalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const ua = window.navigator.userAgent;
    if (/iphone|ipad|ipod/i.test(ua) && !standalone()) setIos(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (hidden || (!evt && !ios)) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const install = async () => {
    if (!evt) return;
    evt.prompt();
    const { outcome } = await evt.userChoice;
    if (outcome === "accepted") setHidden(true);
    setEvt(null);
  };

  return (
    <div data-testid="install-prompt" className="fixed inset-x-3 bottom-3 z-50 flex items-center gap-3 rounded-lg border border-border bg-card p-3 shadow-xl lg:left-auto lg:right-6 lg:w-96">
      <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-md" />
      <div className="min-w-0 flex-1 text-sm">
        <p className="font-semibold">Install Aranya ERP</p>
        {ios && !evt
          ? <p className="text-xs text-muted-foreground">Tap <Share className="inline h-3 w-3" /> Share, then "Add to Home Screen"</p>
          : <p className="text-xs text-muted-foreground">Full-screen app on your home screen</p>}
      </div>
      {evt && <Button size="sm" data-testid="install-app-btn" onClick={install} className="gap-1"><Download className="h-4 w-4" /> Install</Button>}
      <button data-testid="install-dismiss" onClick={dismiss} className="text-muted-foreground hover:text-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
}
